// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__JBGE6","obliqueLineWrap":"membershipbadge_obliqueLineWrap__5VPu_","obliqueLine":"membershipbadge_obliqueLine__1xkBO"};